export {default} from './CohostClubChannel';



// WEBPACK FOOTER //
// ./src/pages/CohostClubChannel/index.ts